// Marks a route that exists and is reachable but has not been built from the
// design yet. It names the Figma frame it is waiting on, so the gap is visible
// while clicking through the site instead of reading as a finished blank page.
export const PendingSection = ({ title, figmaNode, note }) => (
    <section className="mx-auto flex min-h-[60vh] max-w-[1440px] flex-col justify-center gap-3 px-6 py-32 md:px-12">
        <p className="eyebrow text-ink/40">Ainda não implementado</p>
        <h1 className="type-display text-display text-brand">{title}</h1>
        {note && <p className="max-w-[560px] text-body text-ink/70">{note}</p>}
        {figmaNode && (
            <p className="text-[13px] text-ink/50">
                Frame de origem no Figma:{" "}
                <code className="bg-ink/5 px-1.5 py-0.5">{figmaNode}</code>
            </p>
        )}
    </section>
);
